// import http from "./http";

// export const getQuestionGames = async () => {
//   const res = await http.get("selection_game");
//   return res.data;
// };

// export const addQuestionGame = async (data) => {
//   const res = await http.post("selection_game", {
//     action: "add",
//     ...data,
//   });
//   return res.data;
// };

// export const updateQuestionGame = async (id, data) => {
//   const res = await http.post("selection_game", {
//     action: "edit",
//     id,
//     ...data,
//   });
//   return res.data;
// };

// export const deleteQuestionGame = async (id) => {
//   const res = await http.post("selection_game", {
//     action: "delete",
//     id,
//   });
//   return res.data;
// };


import http from "./http";

export const getQuestionGames = async () => {
  const res = await http.get("selection_game");
  return res.data;
};

export const addQuestionGame = async (data) => {
  const res = await http.post("selection_game", {
    action: "add",
    ...data,
  });
  return res.data;
};

export const updateQuestionGame = async (id, data) => {
  const res = await http.post("selection_game", {
    action: "edit",
    id,
    ...data,
  });
  return res.data;
};

export const deleteQuestionGame = async (id) => {
  const res = await http.post("selection_game", {
    action: "delete",
    id,
  });
  return res.data;
};
